import { Box, CircularProgress, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ResponsiveTypography from '@/components/ui/responsive-typography';

export default function ChatLoading() {
  const { t } = useTranslation();

  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 100
      }}
    >
      <ResponsiveTypography>{t('chat_loading')}</ResponsiveTypography>
      <CircularProgress
        size={isSmallScreen ? 40 : 60}
        sx={{
          margin: 2,
          marginRight: 4
        }}
      />
    </Box>
  );
}
